<!-- contactUs -->
<template>
  <div class="contactUs">
    <el-form-item label="联系我们：" prop="contactUs">
      <el-input v-model="ruleForm.contactUs" type="text" class="fl" style="width: 50%;" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'contactUs',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
